import { Bars3Icon, Cog6ToothIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react";
import { useStore } from "../../store";

export const HamburgerMenu: React.FC = () => {
  const { openModal } = useStore();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <button
        // onClick={() => setIsOpen(!isOpen)}
        className="relative p-2 hover:bg-crane-darker rounded transition-colors"
      >
        <Bars3Icon className="w-6 h-6 text-crane-light-gray" />
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute left-0 top-full mt-2 w-48 bg-crane-surface border border-crane-darker rounded-lg shadow-lg z-20">
            <div className="py-2">
              <button
                onClick={() => {
                  openModal("settings");
                  setIsOpen(false);
                }}
                className="w-full px-4 py-2 text-left hover:bg-crane-darker flex items-center space-x-2"
              >
                <Cog6ToothIcon className="w-4 h-4" />
                <span>Settings</span>
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
